exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Preloader */\r\n#pageloader {\r\n  text-align : center; \r\n}\r\n.large-size{\r\n  font-size:40px;\r\n}\r\n  ", ""]);

